import React, { useEffect } from 'react';
import { useDispatch, useSelector } from "react-redux";
import { openModals } from "../redux/modal.slice";
import { useGenerateQuizMutation } from '../api/mutations/questions.mutation';
import ModalsEnum from "../enums/modal.enum";

const TestYourself = () => {
    const dispatch = useDispatch();
    const user = useSelector(state => state.me.data);
    const hasSubscription = user?.user_premium_status?.has_premium_access;
    const questionType = hasSubscription ? 'multiple_choice' : 'short_answer';
    const { mutate } = useGenerateQuizMutation('Test Yourself', true);

    useEffect(() => {
        const params = new URLSearchParams(window.location.search);
        const testYourselfId = params.get("test-yourself");
    
        if (testYourselfId) {
            params.delete("test-yourself");
            const newSearch = params.toString();
            const newUrl =
                window.location.protocol +
                "//" +
                window.location.host +
                window.location.pathname +
                (newSearch ? `?${newSearch}` : "");

            window.history.replaceState({}, document.title, newUrl);

            dispatch(
                openModals({
                    modalIds: [ModalsEnum.LOADING_MODAL],
                    modalData: [
                        { 
                            className: 'big-modal full-size',
                            num_questions: '3',
                            question_type: questionType,
                            categoryTitle: 'Test Yourself'
                        }
                    ]
                })
            );

            mutate({
                question_type: questionType,
                num_questions: '3',
                id: testYourselfId
            });
        }
      }, []);
    return (
        <></>
    );
}
export default TestYourself;